import React, { Fragment } from "react";
import { connect } from "react-redux";
import Moment from "react-moment";

import BlueLogo from "./BlueLogo";

const JobPostApply = ({
  auth: { user, isAuthenticated },
  jobpostitem,
  setShowJob,
  setShowAddAttachment,
}) => {
  return (
    <Fragment>
      <div className="subscription-overlay">
        <div className="subscription-box">
          <i
            className="far fa-times-circle blue fa-3x subscription-x"
            onClick={() => setShowJob(false)}
          ></i>
          <div className="subscription-type-container">
            <p className="nav-logo">
              <BlueLogo />
            </p>
            <h1 className="subscription-name blue">{jobpostitem.jobtitle}</h1>
          </div>
          <div className="subscription-box-container" id="blue-scroll">
            <div className="sub-grid-three-alt">
              <div className="sub-container">
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt blue">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${jobpostitem.avatar}`}
                        className="sub-avi"
                        alt="avatar"
                      />
                    </div>
                  </div>
                  <div className="online-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="blue name-font bold">
                          {jobpostitem.companyname}
                        </span>
                      </li>
                      <li className="user-online-item">
                        {jobpostitem.firstname} {jobpostitem.lastname}
                      </li>
                      <li className="user-online-item">
                        {jobpostitem.location.city},{" "}
                        {jobpostitem.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="sub-container">
                <ul className="stream-container-items-alt">
                  <li className="stream-container-item">
                    Applicants
                    <i className="fas fa-star-of-life blue mx-5"></i>
                    24
                  </li>
                  <li className="stream-container-item">
                    Employment Type
                    <i className="fas fa-star-of-life blue mx-5"></i>
                    {jobpostitem.employmenttype}
                  </li>
                  <li className="stream-container-item">
                    Work Environment
                    <i className="fas fa-star-of-life blue mx-5"></i>
                    {jobpostitem.environment}
                  </li>
                  <li className="stream-container-item">
                    Innovative Employer
                    <i className="fas fa-award mx-5 blue"></i>
                  </li>
                  <li className="stream-container-item">
                    <i className="far fa-clock mx-5 blue"></i>
                    Job Post created on{" "}
                    <i className="fas fa-star-of-life blue mx-5"></i>{" "}
                    <Moment format="MM/DD/YYYY">{jobpostitem.date}</Moment>
                  </li>
                </ul>
              </div>
              <div className="sub-container">
                {user && user.role === "innovator" && (
                  <div className="job-apply-button-container">
                    <button
                      onClick={() => setShowAddAttachment(true)}
                      className="job-apply-button background-blue"
                      type="submit"
                    >
                      Apply
                    </button>
                  </div>
                )}
                {!isAuthenticated && (
                  <div className="job-apply-button-container">
                    <button
                      onClick={() => setShowAddAttachment(true)}
                      className="job-apply-button background-blue"
                      type="submit"
                    >
                      Apply
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="sub-section-container-apply">
              <div className="flex-only">
                <i className="fas fa-briefcase mr-10 fa-lg mt-5 blue"></i>
                <p className="sub-section blue">Job Post</p>
              </div>
            </div>
            <div className="tour-grid">
              <div className="stream-section-container-alt">
                <div className="padding-container">
                  <div className="title-container-info">
                    <div className="border-alt blue">
                      <p className="online-title-alt blue">
                        {jobpostitem.jobtitle}
                      </p>
                    </div>
                  </div>
                  <div className="job-preview-keywords-alt">
                    <ul>
                      {jobpostitem.keywords.map((keyword) => {
                        return (
                          <li className="job-post-keywords">{keyword.text}</li>
                        );
                      })}
                    </ul>
                  </div>
                  <p className="stream-desc-paragraph">
                    {jobpostitem.jobsummary}
                  </p>
                  <p className="stream-desc-paragraph">
                    {jobpostitem.jobdescription}
                  </p>
                  <ul className="stream-container-items">
                    {jobpostitem.responsibilities.map((item) => {
                      return (
                        <li className="stream-container-item">
                          <i className="fas fa-star-of-life blue mx-5"></i>
                          {item.text}
                        </li>
                      );
                    })}
                  </ul>
                  <ul className="stream-container-items">
                    {jobpostitem.qualifications.map((item) => {
                      return (
                        <li className="stream-container-item">
                          <i className="fas fa-star-of-life blue mx-5"></i>
                          {item.text}
                        </li>
                      );
                    })}
                  </ul>
                  <ul className="stream-container-items">
                    {jobpostitem.benefits.map((item) => {
                      return (
                        <li className="stream-container-item">
                          <i className="fas fa-star-of-life blue mx-5"></i>
                          {item.text}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(JobPostApply);
